import hexToRgb from 'src/utils/hexToRgb';
import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

const Popover = defineSlotRecipe({
  slots: ['content', 'header', 'body', 'footer', 'arrow', 'arrowTip'],
  base: {
    content: {
      '--popover-bg': hexToRgb(colors.podcastShade700, 0.95),
      color: colors.white,
    },
    body: {},
    header: {
      borderBottomColor: 'podcastShade500',
      borderBottomWidth: '2px',
    },
  },
  variants: {
    visual: {
      playbackRate: {
        content: {
          width: '210px',
          padding: '0',
          '--popover-bg': 'podcastShade600',
          color: 'white',
        },
        header: {
          borderBottomColor: 'podcastShade500',
          borderBottomWidth: '2px',
        },
      },
    },
  },
});

export default Popover;
